import React from 'react';
import { SectionTitle } from '../ui/SectionTitle';
import { MapPin, Bell, Calendar, Phone, Shield, Smartphone } from 'lucide-react';

const features = [
    {
        icon: Bell,
        title: 'Alerta inmediata',
        desc: 'Recibís un email con la ubicación exacta del escaneo, sin depender de una llamada.',
    },
    {
        icon: MapPin,
        title: 'Ubicación al escanear',
        desc: 'Sabés dónde estaba tu mascota en el momento que alguien la encontró. Sin GPS, sin seguimiento constante.',
    },
    {
        icon: Calendar,
        title: 'Agenda sanitaria',
        desc: 'Recordatorios de vacunas, turnos veterinarios y toda su historia clínica en un solo lugar.',
    },
    {
        icon: Phone,
        title: 'Contacto directo',
        desc: 'Quien encuentra a tu mascota te llama con un solo clic, sin marcar números ni copiar nada.',
    },
    {
        icon: Shield,
        title: 'Sin suscripción',
        desc: 'Pagás una vez y la protección es de por vida. Sin sorpresas, sin cargos ocultos.',
    },
    {
        icon: Smartphone,
        title: 'Sin App',
        desc: 'Cualquier celular con cámara lee el QR. Quien te ayuda no necesita instalar nada.',
    },
];

export function Features() {
    return (
        <section className="py-16 px-4 max-w-6xl mx-auto" id="beneficios">
            <SectionTitle subtitle="Por qué SmartPet es diferente">
                Beneficios que marcan la diferencia
            </SectionTitle>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                {features.map((f, i) => (
                    <div key={i} className="bg-white rounded-2xl p-6 shadow-sp hover:shadow-sp-hover transition group">
                        <div className="w-14 h-14 rounded-2xl bg-sp-light flex items-center justify-center text-sp-primary group-hover:bg-sp-primary group-hover:text-white transition">
                            <f.icon size={28} />
                        </div>
                        <h3 className="text-xl font-black mt-4 text-sp-text">{f.title}</h3>
                        <p className="text-sp-body text-sm mt-1">{f.desc}</p>
                    </div>
                ))}
            </div>
        </section>
    );
}